import { assign as redirectTo } from '@nn/psdl-utility/src/location';

export function makeRelative(path) {
  if (path) {
    if (path.toLowerCase().includes('http')) {
      const relPath = path.replace(/(?:\/\/|[^/]+)*/, '');
      return relPath ? relPath : '/';
    } else if (!path.startsWith('/')) {
      return `/${path}`;
    }
    return path;
  }
}

export function redirect(redirectUrl, fallbackUrl) {
  const relPath = makeRelative(redirectUrl);
  if (relPath && relPath !== '/') {
    redirectTo(relPath);
  } else {
    redirectTo(fallbackUrl);
  }
}
